import * as React from 'react';

const ElectronicsBadge16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.7 1.484 9.687.622a2.6 2.6 0 0 0-3.376 0L5.3 1.484l-1.325.105A2.6 2.6 0 0 0 1.59 3.976l-.105 1.325-.862 1.011a2.6 2.6 0 0 0 0 3.376l.862 1.011.105 1.325a2.6 2.6 0 0 0 2.387 2.387l1.325.106 1.011.861a2.6 2.6 0 0 0 3.376 0l1.011-.861 1.325-.106a2.6 2.6 0 0 0 2.387-2.387l.106-1.325.861-1.011a2.6 2.6 0 0 0 0-3.376l-.861-1.011-.106-1.325a2.6 2.6 0 0 0-2.387-2.387zm-2.025.326 1.14.971c.166.142.374.228.592.245l1.493.12c.51.04.914.445.954.954l.12 1.493c.017.218.103.426.245.592l.971 1.14a1.04 1.04 0 0 1 0 1.35l-.971 1.14a1.04 1.04 0 0 0-.245.592l-.12 1.493a1.04 1.04 0 0 1-.954.954l-1.493.12a1.04 1.04 0 0 0-.592.245l-1.14.971a1.04 1.04 0 0 1-1.35 0l-1.14-.971a1.04 1.04 0 0 0-.592-.245l-1.493-.12a1.04 1.04 0 0 1-.954-.954l-.12-1.493a1.04 1.04 0 0 0-.245-.592l-.971-1.14a1.04 1.04 0 0 1 0-1.35l.971-1.14a1.04 1.04 0 0 0 .245-.592l.12-1.493c.04-.51.445-.914.954-.954l1.493-.12a1.04 1.04 0 0 0 .592-.245l1.14-.971a1.04 1.04 0 0 1 1.35 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.908 5.76a.75.75 0 0 1 1.245.837C5.183 8.038 6.169 10.25 8 10.25s2.817-2.212 1.847-3.653a.75.75 0 0 1 1.245-.837c1.61 2.394-.08 5.99-3.092 5.99S3.297 8.154 4.908 5.76"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 3.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 8 3.75"
  }
));
ElectronicsBadge16.Size = 16;
ElectronicsBadge16.Title = "ElectronicsBadge";

export { ElectronicsBadge16 as default };
